import { EventViewData } from 'components/eventView/pages/eventData';

export const BMEvent: EventViewData = {
    eventId: 'bm',
    mapId: '5cf4e6d9-1747-49fb-bd15-dfb03ab06156',
    guideId: '04d41840-6b8f-46c9-b4ab-d11aa71b04ff',
    eventInfo: {}
};
